/**
 * URL scheme allow-list for product card rendering.
 *
 * Card `url` and `image_url` come from the Magento publisher → R2 → D1
 * pipeline. JSON Schema declares them as `format: "uri"`, but `ajv-formats`
 * URI validation follows RFC 3986, which permits any scheme — including
 * `javascript:`, `data:`, `vbscript:`, etc. A compromised or
 * misconfigured Magento publishing the wrong URL would otherwise allow
 * stored XSS via `<a href>` or `<img src>` in the chat widget.
 *
 * This module is the single trust gate at the rendering layer:
 *   - http: and https: pass through unchanged
 *   - everything else (including malformed URLs) returns null
 *
 * Callers must handle `null` by NOT setting the corresponding attribute.
 */

const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

export function safeHttpUrl(raw: string | null | undefined): string | null {
  if (typeof raw !== 'string' || raw.length === 0) return null;
  try {
    const parsed = new URL(raw);
    if (ALLOWED_PROTOCOLS.has(parsed.protocol)) return raw;
  } catch {
    // Malformed URL — fall through to null.
  }
  return null;
}
